import { render, staticRenderFns } from "./Donut.vue?vue&type=template&id=0a64c33e&scoped=true&"
import script from "./Donut.vue?vue&type=script&lang=js&"
export * from "./Donut.vue?vue&type=script&lang=js&"
import style0 from "./Donut.vue?vue&type=style&index=0&id=0a64c33e&prod&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a64c33e",
  null
  
)

export default component.exports